import {PolymerElement, html} from '@polymer/polymer';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';
import {KeliChartBehavior} from './keli-chart-behavior.js';
import {Chart, LineController, LineElement} from 'chart.js';
Chart.register(LineController, LineElement);

class KeliChartLine extends ScopeBinding(KeliChartBehavior(PolymerElement)) {
  static get template() {
    return html`
<style>
:host {
  display: block;
}
</style>
<keli-chart-controller id="controller" keliname="_t"></keli-chart-controller>
<div id="outerChartContainer">
  <div id="chartContainer">
    <canvas id="chartElement" width="400" height="200"></canvas>
  </div>
</div>`;
  }

  static get is() {
    return 'keli-chart-line';
  }

  static get properties() {
    return {
      keliControlTypes: {type: Array, value: ['linechart']},
      chartType: {type: String, value: 'line'},
      chartOptions: {
        type: Object, value() {
          return {
            elements: {
              line: {
                tension: .1,
                fill: true
              }
            }
          };
        }
      }
    }
  }
}

customElements.define(KeliChartLine.is, KeliChartLine);
export {KeliChartLine};
